import { render, staticRenderFns } from "./FormUser2.vue?vue&type=template&id=3ef2494c&"
import script from "./FormUser2.vue?vue&type=script&lang=js&"
export * from "./FormUser2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports